// NOTE (Ben, 2026-03-09): Adapted from https://elements.ai-sdk.dev/components/message

import type { ComponentProps, HTMLAttributes } from "react";

import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import twMerge from "@replo/design-system/utils/twMerge";

export const Message = ({
  className,
  from,
  ...props
}: HTMLAttributes<HTMLDivElement> & { from: "assistant" | "user" }) => (
  <div
    className={twMerge(
      "group flex w-full flex-col gap-2",
      from === "user"
        ? "is-user ml-auto justify-end max-w-[calc(100%-36px)]"
        : "is-assistant",
      className,
    )}
    {...props}
  />
);

export const MessageContent = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={twMerge(
      "flex min-w-0 max-w-full flex-col gap-2 overflow-hidden text-sm text-default",
      "group-[.is-user]:ml-auto group-[.is-user]:w-fit group-[.is-user]:bg-surface group-[.is-user]:rounded-2xl group-[.is-user]:rounded-tr-sm group-[.is-user]:px-3 group-[.is-user]:py-2",
      "group-[.is-assistant]:w-full",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const MessageActions = ({
  className,
  children,
  ...props
}: ComponentProps<"div">) => (
  <div
    className={twMerge(
      "flex items-center gap-1 group-[.is-user]:justify-end group-[.is-assistant]:ml-9",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

type MessageActionProps = ComponentProps<typeof Button> & {
  tooltip?: string;
  label?: string;
};

export const MessageAction = ({
  tooltip,
  children,
  label,
  variant = "tertiary",
  size = "sm",
  ...props
}: MessageActionProps) => {
  const button = (
    <Button size={size} type="button" variant={variant} {...props}>
      {children}
      <span className="sr-only">{label ?? tooltip}</span>
    </Button>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{button}</Tooltip>;
  }

  return button;
};

// TODO (Ben, 2026-03-09, REPL-24856): Add streamdown plugins
// const streamdownPlugins = { cjk, code, math, mermaid };

// type MessageResponseProps = ComponentProps<typeof Streamdown> & {
//   className?: string;
// };

// export const MessageResponse = memo(
//   ({ className, ...props }: MessageResponseProps) => (
//     <Streamdown
//       className={twMerge(
//         "size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
//         className,
//       )}
//       plugins={streamdownPlugins}
//       rehypePlugins={[rehypeChatToken, rehypeColorChip]}
//       components={chatTokenComponents}
//       allowedTags={allowedChatTags}
//       {...props}
//     />
//   ),
//   (prevProps, nextProps) => prevProps.children === nextProps.children,
// );

// MessageResponse.displayName = "MessageResponse";
